EMMY.modal_izimodal = {
  init: function () {

    $(".izimodal").iziModal({
        onClosing: function () {
            $('.la-view').removeClass('iziModal-opened-noscroll');
        }
    });

      if($('.video_file').val() != undefined) {
          $(window).on('resize', function () {
              setTimeout(function () {
                  _resizeVideoHeight();
              }, 200)
          });
      }

    $(document).on('click', '.new-modal-trigger', function (event) {
      event.preventDefault();
      event.stopPropagation();
      target = $(this).data('target');
      $(target).iziModal('open');
      $('.la-view').addClass('iziModal-opened-noscroll');

      if ($(this).hasClass('preview')) {
        $(target).iziModal('setWidth', '90%');
          $(document).on('closing', target, function (e) {
              // console.log('Modal is closing', $(this).html(), e);
              // var theProtocol = location.protocol,
              //     theURL = theProtocol + "//players.brightcove.net",
              //
              //     // Get a reference to the iframe element
              //     iframeTag = document.querySelector("iframe"),
              //
              //     // Retrieve window object needed for postMessage
              //     win = iframeTag.contentWindow;
              // console.log('theURL:', theURL);
              // console.log('win:', win);
              // win.postMessage("pauseVideo", theURL)
              // myPlayer.pause();
          })

          if($('.video_file').val() != undefined) {
              $(document).on('opened', target, function (e) {
                  e.stopPropagation();
                  let app = this;
                  _resizeVideoHeight();
              });
          }
      }
    });
  }
};

function _resizeVideoHeight() {
    const videoPlayerElement = $('.videoplayer .video-js');
    const ratio = Math.min(1, ($(window).height() - 140) / videoPlayerElement.height());
    const windowWidth = $(window).width() - 260;
    if (ratio === 1) {
        videoPlayerElement.css('height', '100%');
        videoPlayerElement.css('width', '100%');
    } else {
        videoPlayerElement.css('height', videoPlayerElement.height() * ratio + 'px');
        videoPlayerElement.css('width', videoPlayerElement.width() * ratio + 'px');
        videoPlayerElement.css('left', (windowWidth - videoPlayerElement.width()) * .5 + 'px');
    }
}
